export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResearchAccordion.vue?vue&type=template&id=5b7988b0"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/ResearchAccordion.vue?vue&type=template&id=5b7988b0
// module id = 416
// module chunks = 0